import React, { PropTypes } from 'react';

// Components
import Image from '../../image/Image';
import Div from '../../div/Div';
import Label from '../../label/Label';
import List from '../list/List';

const propTypes = {
  extra: PropTypes.bool,
  content: PropTypes.object.isRequired,
};

const Content = (props) => {
  const content = props.content;

  const header = content.header &&
    <Div className="header">
      {content.header}
    </Div>;

  const meta = content.meta &&
    <Div className="meta">
    {content.meta}
    </Div>;

  const description = content.description &&
    <Div className="description">
      {content.description}
    </Div>;

  const label = content.label &&
    <Label icon={content.label.icon} extraClasses={content.label.extraClasses}>
      {content.label.text}
    </Label>;

  const image = content.image &&
    <div className="ui center aligned container">
      <Image image={content.image} />
    </div>
  ;

  const list = props.content.list &&
    <List list={props.content.list} />;

  const className = `${props.extra} content`;

  return (
    <div className={className}>
      {header}
      {meta}
      {label}
      {description}
      {image}
      {list}
    </div>
  );
};

Content.propTypes = propTypes;

export default Content;



/** WEBPACK FOOTER **
 ** ./src/components/layout/sui/contents/content/Content.js
 **/